import * as React from 'react';
import { Table } from 'reactstrap';
import Icon from '../../../widgets/Icons';
import LightTooltip, {
  TOOLTIP_DELAY_INSTANT_SHOW_INSTANT_HIDE,
} from '../../../widgets/LightTooltip';

export const ACCOUNT_TYPE_TOOLTIP = (
  <LightTooltip
    size="lg"
    tooltip={
      <Table size="sm">
        <tbody>
          <tr>
            <th>Cloud Detection and Response:</th>
            <td>
              Account used to collect logs from the cloud application for event
              monitoring.
            </td>
          </tr>
          <tr>
            <th>Cloud Security Posture Management:</th>
            <td>
              Account used to scan the cloud application for misconfiguration
              vulnerabilities.
            </td>
          </tr>
          <tr>
            <th>Federated Authentication:</th>
            <td>
              Account used to enable using your own identity provider for single
              sign-on.
            </td>
          </tr>
          <tr>
            <th>ITSM Ticketing Integration:</th>
            <td>Account used to integrate with ITSM Ticketing system.</td>
          </tr>
        </tbody>
      </Table>
    }
    delay={TOOLTIP_DELAY_INSTANT_SHOW_INSTANT_HIDE}
    placement="bottom"
  >
    <Icon.Question size={14} className="mx-3" />
  </LightTooltip>
);

export const ACCOUNT_PURPOSE_TEXT = {
  scan: 'Cloud Security Posture Management',
  log: 'Cloud Detection and Response',
  auth: 'Federated Authentication',
  itsm: 'ITSM Ticketing Integration',
};
